import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import { useNavigate } from 'react-router-dom';
import leftarrow from '../../../safreeimg/left-arrow.png';

const AddNewMember = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedGuardians, setSelectedGuardians] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const rowsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('No authentication token found');
          setLoading(false);
          return;
        }

        // Extract subGroupId from URL (after # symbol)
        const groupId = window.location.href.split('#')[1];
        if (!groupId) {
          setError('No subGroupId found in URL');
          setLoading(false);
          return;
        }

        // Fetch data from new API
        const response = await axios.get(
          `https://api.safree.org/api-v2022/organization/auth/v1/users-to-add-in-group/${groupId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          setUsers(response.data.data);
        } else {
          setError('Failed to fetch users');
        }
      } catch (err) {
        console.error('Error fetching users:', err);
        setError('An error occurred while fetching users: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredUsers = users.filter((user) =>
    (user.name?.toLowerCase() || "").includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const currentRows = filteredUsers.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );


  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const maxPageNumbersToShow = 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const handleSelectAll = (type) => {
    if (type === "members") {
      const currentPageUserIds = currentRows.map((user) => user.userId);

      if (selectedMembers.length === currentPageUserIds.length) {
        setSelectedMembers(selectedMembers.filter((id) => !currentPageUserIds.includes(id)));
      } else {
        setSelectedMembers([...selectedMembers, ...currentPageUserIds.filter((id) => !selectedGuardians.includes(id))]);
      }
    } else if (type === "guardians") {
      const currentPageUserIds = currentRows.map((user) => user.userId);

      if (selectedGuardians.length === currentPageUserIds.length) {
        setSelectedGuardians(selectedGuardians.filter((id) => !currentPageUserIds.includes(id)));
      } else {
        setSelectedGuardians([...selectedGuardians, ...currentPageUserIds.filter((id) => !selectedMembers.includes(id))]);
      }
    }
  };

  const handleSelectUser = (userId, type) => {
    if (type === 'members') {
      setSelectedMembers((prevSelected) => {
        if (prevSelected.includes(userId)) {
          return prevSelected.filter((id) => id !== userId);
        } else {
          return [...prevSelected, userId];
        }
      });
      setSelectedGuardians((prevSelected) => prevSelected.filter((id) => id !== userId));
    } else if (type === 'guardians') {
      setSelectedGuardians((prevSelected) => {
        if (prevSelected.includes(userId)) {
          return prevSelected.filter((id) => id !== userId);
        } else {
          return [...prevSelected, userId];
        }
      });
      setSelectedMembers((prevSelected) => prevSelected.filter((id) => id !== userId));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedMembers.length === 0 && selectedGuardians.length === 0) {
      setError('Please select at least one member.');
      return;
    }

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        setError('No authentication token found');
        return;
      }

      const groupId = window.location.href.split('#')[1];
      console.log('Group ID:', groupId);

      const response = await axios.post(
        'https://api.safree.org/api-v2022/organization/auth/v1/group-add-member',
        {
          groupId: groupId,
          members: selectedMembers,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setSelectedMembers([]);
        setError(null);
        alert('Group member added successfully!');

        window.history.back();
      } else {
        setError('Failed to create group');
      }
    } catch (err) {
      console.error('Error creating group:', err);
      setError('An error occurred while creating the group: ' + err.message);
    }
  };


  const handleBackClick = () => {
    navigate(-1);
  };

  if (loading) return <div className="loading"><img src={Loader} alt="" /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-6">
          <p className="sub-heading"> <img onClick={handleBackClick} className="back-button" src={leftarrow} alt="" />Select New Members</p>
        </div>
        <div className="col-md-6 dispflx">

          {/* Search Bar */}
          <input
            type="text"
            className="search-box"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <form className="styled-form d" onSubmit={handleSubmit}>
            <button type="submit" className="btn btn-submit">Add Member</button>
          </form>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="table-container tblmnual">
            <table className="styled-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectedMembers.length === users.length - selectedGuardians.length}
                      onChange={() => handleSelectAll('members')}
                    />
                  </th>
                  <th>S. No</th>
                  <th>Name</th>
                  <th>Email</th>
                  {/* <th>Member</th> */}

                </tr>
              </thead>
              <tbody>
                {currentRows.map((user, index) => (
                  <tr key={user.userId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedMembers.includes(user.userId)}
                        onChange={() => handleSelectUser(user.userId, 'members')}
                        disabled={selectedGuardians.includes(user.userId)}
                      />
                    </td>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    {/* <td>Member</td> */}
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="pagination-container">
              <button
                className="pagination-btn"
                onClick={() => handlePageChange('prev')}
                disabled={currentPage === 1}
              >
                &laquo; Prev
              </button>
              {getPageNumbers().map((page) => (
                <button
                  key={page}
                  className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}
              <button
                className="pagination-btn"
                onClick={() => handlePageChange('next')}
                disabled={currentPage === totalPages}
              >
                Next &raquo;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewMember;
